<template>
  <div data-qa="common-benefits">
    <Benefits data-qa="benefits" />
  </div>
</template>

<script>
import Benefits from './Benefits.vue'

export default {
  name: 'CommonBenefits',
  components: {
    Benefits
  }
}
</script>
